import React from 'react';
import { LockIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
type SectionCTAProps = {
  label: string;
  tone?: 'dark' | 'light';
};
export function SectionCTA({
  label,
  tone = 'dark'
}: SectionCTAProps) {
  return <div className="mx-auto mt-12 w-full max-w-xl" data-id="element-82" data-mp="1lcl9hk25sujf">
      <CTAButton label={label} subLabel="Instant access · One-time payment of $27" data-id="element-83" data-mp="1qbemzchg4ljl" />
      <p className={`mt-3 flex items-center justify-center gap-1.5 text-xs font-medium ${tone === 'dark' ? 'text-white/60' : 'text-navy/60'}`} data-id="element-84" data-mp="1bna3i6akk5zr">
        <LockIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-85" data-mp="1gfl3f95b7rsb" />
        Secure checkout · Lifetime access · Digital delivery
      </p>
    </div>;
}